module.exports = __webpack_public_path__ + "static/media/solidity.5ee49ef8.png";